module.exports = __webpack_public_path__ + "static/media/logo-zurich.bd496d3a.svg";